
import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { toast } from 'sonner';

const ClipboardBox = ({ id }) => {
  const handleCopy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(id);
    toast.success("Copied to clipboard");
  };

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #E5E7EB',
        borderRadius: '999px',
        padding: '6px 12px',
        width: 'fit-content',
        height: '32px',
        backgroundColor: '#FFFFFF',
      }}
    >
      <Typography
        sx={{
          fontWeight: '500',
          fontSize: '12px',
          color: '#000000',
          mr: 1,
        }}
      >
        {id && id.length > 8 ? `${id.slice(0, -8)}...` : id}
      </Typography>
      <IconButton
        onClick={handleCopy}
        sx={{
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <ContentCopy
          sx={{
            fontSize: 16,
            color: '#64748B',
          }}
        />
      </IconButton>
    </Box>
  );
};

export default ClipboardBox;
